// package: accountmanager
// file: account-manager.proto

var account_manager_pb = require("./account-manager_pb");
var grpc = require("@improbable-eng/grpc-web").grpc;

var AccountManager = (function () {
  function AccountManager() {}
  AccountManager.serviceName = "accountmanager.AccountManager";
  return AccountManager;
}());

AccountManager.AddAccount = {
  methodName: "AddAccount",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AddAccountReq,
  responseType: account_manager_pb.AddAccountReply
};

AccountManager.GetAccountInfo = {
  methodName: "GetAccountInfo",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.GetAccountInfoReq,
  responseType: account_manager_pb.GetAccountInfoReply
};

AccountManager.DeleteAccount = {
  methodName: "DeleteAccount",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.DeleteAccountReq,
  responseType: account_manager_pb.DeleteAccountReply
};

AccountManager.GetAccountList = {
  methodName: "GetAccountList",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AccountListReq,
  responseType: account_manager_pb.AccountListReply
};

AccountManager.UpdateAccount = {
  methodName: "UpdateAccount",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.UpdateAccountReq,
  responseType: account_manager_pb.UpdateAccountReply
};

AccountManager.EnableAccount = {
  methodName: "EnableAccount",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.EnableAccountReq,
  responseType: account_manager_pb.EnableAccountReply
};

AccountManager.CloseAccountsTrades = {
  methodName: "CloseAccountsTrades",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.CloseAccountsTradesReq,
  responseType: account_manager_pb.CloseAccountsTradesReply
};

AccountManager.OpenTradeWarning = {
  methodName: "OpenTradeWarning",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.OpenTradeWarningReq,
  responseType: account_manager_pb.OpenTradeWarningReply
};

AccountManager.ActivateBetaConnection = {
  methodName: "ActivateBetaConnection",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.ActivateBetaConnectionReq,
  responseType: account_manager_pb.ActivateBetaConnectionReply
};

AccountManager.GetUsersTradingPlatforms = {
  methodName: "GetUsersTradingPlatforms",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.GetUsersTradingPlatformsReq,
  responseType: account_manager_pb.GetUsersTradingPlatformsReply
};

AccountManager.ActivateAnalyzer = {
  methodName: "ActivateAnalyzer",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.ActivateAnalyzerReq,
  responseType: account_manager_pb.ActivateAnalyzerReply
};

AccountManager.UpsertEPSettings = {
  methodName: "UpsertEPSettings",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.UpsertEPSettingsReq,
  responseType: account_manager_pb.UpsertEPSettingsReply
};

AccountManager.GetEPSettings = {
  methodName: "GetEPSettings",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.GetEPSettingsReq,
  responseType: account_manager_pb.GetEPSettingsReply
};

AccountManager.UpsertMcpSettings = {
  methodName: "UpsertMcpSettings",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.UpsertMcpSettingsReq,
  responseType: account_manager_pb.UpsertMcpSettingsReply
};

AccountManager.GetMcpSettings = {
  methodName: "GetMcpSettings",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.GetMcpSettingsReq,
  responseType: account_manager_pb.GetMcpSettingsReply
};

AccountManager.GetMcpAuditLogs = {
  methodName: "GetMcpAuditLogs",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.GetMcpAuditLogsReq,
  responseType: account_manager_pb.GetMcpAuditLogsReply
};

AccountManager.ListIndicatorScripts = {
  methodName: "ListIndicatorScripts",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.ListIndicatorScriptsReq,
  responseType: account_manager_pb.ListIndicatorScriptsReply
};

AccountManager.GetIndicatorScript = {
  methodName: "GetIndicatorScript",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.GetIndicatorScriptReq,
  responseType: account_manager_pb.GetIndicatorScriptReply
};

AccountManager.CreateIndicatorScript = {
  methodName: "CreateIndicatorScript",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.CreateIndicatorScriptReq,
  responseType: account_manager_pb.CreateIndicatorScriptReply
};

AccountManager.UpdateIndicatorScript = {
  methodName: "UpdateIndicatorScript",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.UpdateIndicatorScriptReq,
  responseType: account_manager_pb.UpdateIndicatorScriptReply
};

AccountManager.DeleteIndicatorScript = {
  methodName: "DeleteIndicatorScript",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.DeleteIndicatorScriptReq,
  responseType: account_manager_pb.DeleteIndicatorScriptReply
};

AccountManager.ListAccountSymbols = {
  methodName: "ListAccountSymbols",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.ListAccountSymbolsReq,
  responseType: account_manager_pb.ListAccountSymbolsReply
};

AccountManager.EnableAccountSymbol = {
  methodName: "EnableAccountSymbol",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.EnableAccountSymbolReq,
  responseType: account_manager_pb.EnableAccountSymbolReply
};

AccountManager.EnableAllAccountSymbols = {
  methodName: "EnableAllAccountSymbols",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.EnableAllAccountSymbolsReq,
  responseType: account_manager_pb.EnableAllAccountSymbolsReply
};

AccountManager.CompareSymbols = {
  methodName: "CompareSymbols",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.CompareSymbolsReq,
  responseType: account_manager_pb.CompareSymbolsReply
};

AccountManager.SymbolStats = {
  methodName: "SymbolStats",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.SymbolStatsReq,
  responseType: account_manager_pb.SymbolStatsReply
};

AccountManager.UnmappedSymbolList = {
  methodName: "UnmappedSymbolList",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.UnmappedSymbolListReq,
  responseType: account_manager_pb.UnmappedSymbolListReply
};

AccountManager.AutoMapSymbols = {
  methodName: "AutoMapSymbols",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AutoMapSymbolsReq,
  responseType: account_manager_pb.AutoMapSymbolsReply
};

AccountManager.MappedSymbolList = {
  methodName: "MappedSymbolList",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.MappedSymbolListReq,
  responseType: account_manager_pb.MappedSymbolListReply
};

AccountManager.GroupList = {
  methodName: "GroupList",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.GroupListReq,
  responseType: account_manager_pb.GroupListReply
};

AccountManager.SymbolLotOverride = {
  methodName: "SymbolLotOverride",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.SymbolLotOverrideReq,
  responseType: account_manager_pb.SymbolLotOverrideReply
};

AccountManager.DeleteSymbolLotOverride = {
  methodName: "DeleteSymbolLotOverride",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.DeleteSymbolLotOverrideReq,
  responseType: account_manager_pb.DeleteSymbolLotOverrideReply
};

AccountManager.AdminDeleteSymbolLotOverride = {
  methodName: "AdminDeleteSymbolLotOverride",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminDeleteSymbolLotOverrideReq,
  responseType: account_manager_pb.AdminDeleteSymbolLotOverrideReply
};

AccountManager.AdminSymbolLotOverride = {
  methodName: "AdminSymbolLotOverride",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminSymbolLotOverrideReq,
  responseType: account_manager_pb.AdminSymbolLotOverrideReply
};

AccountManager.ListCopiedTrades = {
  methodName: "ListCopiedTrades",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.ListCopiedTradesReq,
  responseType: account_manager_pb.ListCopiedTradesReply
};

AccountManager.GetCopiedTradeLogs = {
  methodName: "GetCopiedTradeLogs",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.CopiedTradeLogsReq,
  responseType: account_manager_pb.CopiedTradeLogsReply
};

AccountManager.UpdateDedicatedEnv = {
  methodName: "UpdateDedicatedEnv",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.UpdateDedicatedEnvReq,
  responseType: account_manager_pb.UpdateDedicatedEnvReply
};

AccountManager.GetUsersDedicatedEnvList = {
  methodName: "GetUsersDedicatedEnvList",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.GetUsersDedicatedEnvListReq,
  responseType: account_manager_pb.GetUsersDedicatedEnvListReply
};

AccountManager.CheckAvailableEnv = {
  methodName: "CheckAvailableEnv",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.CheckAvailableEnvReq,
  responseType: account_manager_pb.CheckAvailableEnvReply
};

AccountManager.ChangeAccountEnv = {
  methodName: "ChangeAccountEnv",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.ChangeAccountEnvReq,
  responseType: account_manager_pb.ChangeAccountEnvReply
};

AccountManager.GetUsersRithmicProfiles = {
  methodName: "GetUsersRithmicProfiles",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.GetUsersRithmicProfilesReq,
  responseType: account_manager_pb.GetUsersRithmicProfilesReply
};

AccountManager.ChangeProfileEnv = {
  methodName: "ChangeProfileEnv",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.ChangeProfileEnvReq,
  responseType: account_manager_pb.ChangeProfileEnvReply
};

AccountManager.AdminAddAccount = {
  methodName: "AdminAddAccount",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminAddAccountReq,
  responseType: account_manager_pb.AdminAddAccountReply
};

AccountManager.AdminChangeAccountConnectionType = {
  methodName: "AdminChangeAccountConnectionType",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminChangeAccountConnectionTypeReq,
  responseType: account_manager_pb.AdminChangeAccountConnectionTypeReply
};

AccountManager.AdminGetUserAccounts = {
  methodName: "AdminGetUserAccounts",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminGetUserAccountsReq,
  responseType: account_manager_pb.AdminGetUserAccountsReply
};

AccountManager.AdminGetAccountInfo = {
  methodName: "AdminGetAccountInfo",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminGetAccountInfoReq,
  responseType: account_manager_pb.AdminGetAccountInfoReply
};

AccountManager.AdminListAccounts = {
  methodName: "AdminListAccounts",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminListAccountsReq,
  responseType: account_manager_pb.AdminListAccountsReply
};

AccountManager.AdminDeleteAccount = {
  methodName: "AdminDeleteAccount",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminDeleteAccountReq,
  responseType: account_manager_pb.AdminDeleteAccountReply
};

AccountManager.AdminGetAccountStatus = {
  methodName: "AdminGetAccountStatus",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminGetAccountStatusReq,
  responseType: account_manager_pb.AdminGetAccountStatusReply
};

AccountManager.AdminCopierLogs = {
  methodName: "AdminCopierLogs",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminCopierLogsReq,
  responseType: account_manager_pb.AdminCopierLogsReply
};

AccountManager.AdminCopiedTradeLogs = {
  methodName: "AdminCopiedTradeLogs",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.CopiedTradeLogsReq,
  responseType: account_manager_pb.CopiedTradeLogsReply
};

AccountManager.AdminEnableAccount = {
  methodName: "AdminEnableAccount",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminEnableAccountReq,
  responseType: account_manager_pb.AdminEnableAccountReply
};

AccountManager.AdminCloseAccountsTrades = {
  methodName: "AdminCloseAccountsTrades",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminCloseAccountsTradesReq,
  responseType: account_manager_pb.AdminCloseAccountsTradesReply
};

AccountManager.AdminGetEPSettings = {
  methodName: "AdminGetEPSettings",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminGetEPSettingsReq,
  responseType: account_manager_pb.AdminGetEPSettingsReply
};

AccountManager.AdminGetUsersDedicatedEnvList = {
  methodName: "AdminGetUsersDedicatedEnvList",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminGetUsersDedicatedEnvListReq,
  responseType: account_manager_pb.AdminGetUsersDedicatedEnvListReply
};

AccountManager.AdminChangeAccountEnv = {
  methodName: "AdminChangeAccountEnv",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminChangeAccountEnvReq,
  responseType: account_manager_pb.AdminChangeAccountEnvReply
};

AccountManager.AdminGetUsersRithmicProfiles = {
  methodName: "AdminGetUsersRithmicProfiles",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.GetUsersRithmicProfilesReq,
  responseType: account_manager_pb.GetUsersRithmicProfilesReply
};

AccountManager.AdminChangeProfileEnv = {
  methodName: "AdminChangeProfileEnv",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.ChangeProfileEnvReq,
  responseType: account_manager_pb.ChangeProfileEnvReply
};

AccountManager.AdminActivateBetaConnection = {
  methodName: "AdminActivateBetaConnection",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminActivateBetaConnectionReq,
  responseType: account_manager_pb.AdminActivateBetaConnectionReply
};

AccountManager.AdminBlockAccount = {
  methodName: "AdminBlockAccount",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminBlockAccountReq,
  responseType: account_manager_pb.AdminBlockAccountReply
};

AccountManager.AdminBlockAccountList = {
  methodName: "AdminBlockAccountList",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminBlockAccountListReq,
  responseType: account_manager_pb.AdminBlockAccountListReply
};

AccountManager.AdminSyncSymbols = {
  methodName: "AdminSyncSymbols",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminSyncSymbolsReq,
  responseType: account_manager_pb.AdminSyncSymbolsReply
};

AccountManager.AdminListAccountSymbols = {
  methodName: "AdminListAccountSymbols",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminListAccountSymbolsReq,
  responseType: account_manager_pb.AdminListAccountSymbolsReply
};

AccountManager.AdminCompareSymbols = {
  methodName: "AdminCompareSymbols",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminCompareSymbolsReq,
  responseType: account_manager_pb.AdminCompareSymbolsReply
};

AccountManager.AdminSymbolStats = {
  methodName: "AdminSymbolStats",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminSymbolStatsReq,
  responseType: account_manager_pb.AdminSymbolStatsReply
};

AccountManager.AdminUnmappedSymbolList = {
  methodName: "AdminUnmappedSymbolList",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminUnmappedSymbolListReq,
  responseType: account_manager_pb.AdminUnmappedSymbolListReply
};

AccountManager.AdminAutoMapSymbols = {
  methodName: "AdminAutoMapSymbols",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminAutoMapSymbolsReq,
  responseType: account_manager_pb.AdminAutoMapSymbolsReply
};

AccountManager.AdminMappedSymbolList = {
  methodName: "AdminMappedSymbolList",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminMappedSymbolListReq,
  responseType: account_manager_pb.AdminMappedSymbolListReply
};

AccountManager.AdminGroupList = {
  methodName: "AdminGroupList",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminGroupListReq,
  responseType: account_manager_pb.AdminGroupListReply
};

AccountManager.AdminEnableAccountSymbol = {
  methodName: "AdminEnableAccountSymbol",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminEnableAccountSymbolReq,
  responseType: account_manager_pb.AdminEnableAccountSymbolReply
};

AccountManager.AdminEnableAllAccountSymbols = {
  methodName: "AdminEnableAllAccountSymbols",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminEnableAllAccountSymbolsReq,
  responseType: account_manager_pb.AdminEnableAllAccountSymbolsReply
};

AccountManager.AdminAddPool = {
  methodName: "AdminAddPool",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminAddPoolReq,
  responseType: account_manager_pb.AdminAddPoolReply
};

AccountManager.AdminUpdatePool = {
  methodName: "AdminUpdatePool",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminUpdatePoolReq,
  responseType: account_manager_pb.AdminUpdatePoolReply
};

AccountManager.AdminDeletePool = {
  methodName: "AdminDeletePool",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminDeletePoolReq,
  responseType: account_manager_pb.AdminDeletePoolReply
};

AccountManager.AdminListPools = {
  methodName: "AdminListPools",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminListPoolsReq,
  responseType: account_manager_pb.AdminListPoolsReply
};

AccountManager.AdminAddSymbolPool = {
  methodName: "AdminAddSymbolPool",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminAddSymbolPoolReq,
  responseType: account_manager_pb.AdminAddSymbolPoolReply
};

AccountManager.AdminUpdateSymbolPool = {
  methodName: "AdminUpdateSymbolPool",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminUpdateSymbolPoolReq,
  responseType: account_manager_pb.AdminUpdateSymbolPoolReply
};

AccountManager.AdminDeleteSymbolPool = {
  methodName: "AdminDeleteSymbolPool",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminDeleteSymbolPoolReq,
  responseType: account_manager_pb.AdminDeleteSymbolPoolReply
};

AccountManager.AdminAddIpPool = {
  methodName: "AdminAddIpPool",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminAddIpPoolReq,
  responseType: account_manager_pb.AdminAddIpPoolReply
};

AccountManager.AdminUpdateIpPool = {
  methodName: "AdminUpdateIpPool",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminUpdateIpPoolReq,
  responseType: account_manager_pb.AdminUpdateIpPoolReply
};

AccountManager.AdminDeleteIpPool = {
  methodName: "AdminDeleteIpPool",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminDeleteIpPoolReq,
  responseType: account_manager_pb.AdminDeleteIpPoolReply
};

AccountManager.AdminAddSymbolOverride = {
  methodName: "AdminAddSymbolOverride",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminAddSymbolOverrideReq,
  responseType: account_manager_pb.AdminAddSymbolOverrideReply
};

AccountManager.AdminListSymbolOverrides = {
  methodName: "AdminListSymbolOverrides",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminListSymbolOverridesReq,
  responseType: account_manager_pb.AdminListSymbolOverridesReply
};

AccountManager.AdminDeleteSymbolOverride = {
  methodName: "AdminDeleteSymbolOverride",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminDeleteSymbolOverrideReq,
  responseType: account_manager_pb.AdminDeleteSymbolOverrideReply
};

AccountManager.AdminUpdateSymbolOverride = {
  methodName: "AdminUpdateSymbolOverride",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminUpdateSymbolOverrideReq,
  responseType: account_manager_pb.AdminUpdateSymbolOverrideReply
};

AccountManager.AdminGetClusterList = {
  methodName: "AdminGetClusterList",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminGetClusterListReq,
  responseType: account_manager_pb.AdminGetClusterListReply
};

AccountManager.AdminSwitchConnectionCluster = {
  methodName: "AdminSwitchConnectionCluster",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminSwitchConnectionClusterReq,
  responseType: account_manager_pb.AdminSwitchConnectionClusterReply
};

AccountManager.GetAllowedCTraderAccounts = {
  methodName: "GetAllowedCTraderAccounts",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.GetAllowedCTraderAccountsReq,
  responseType: account_manager_pb.GetAllowedCTraderAccountsReply
};

AccountManager.SaveCTraderAuthInfo = {
  methodName: "SaveCTraderAuthInfo",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.SaveCTraderAuthInfoReq,
  responseType: account_manager_pb.SaveCTraderAuthInfoReply
};

AccountManager.UpdateCTraderAuthInfo = {
  methodName: "UpdateCTraderAuthInfo",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.UpdateCTraderAuthInfoReq,
  responseType: account_manager_pb.UpdateCTraderAuthInfoReply
};

AccountManager.DeleteCTraderAuthInfo = {
  methodName: "DeleteCTraderAuthInfo",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.DeleteCTraderAuthInfoReq,
  responseType: account_manager_pb.DeleteCTraderAuthInfoReply
};

AccountManager.GetCTraderAuthenticatedProfileList = {
  methodName: "GetCTraderAuthenticatedProfileList",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.GetCTraderAuthenticatedProfileListReq,
  responseType: account_manager_pb.GetCTraderAuthenticatedProfileListReply
};

AccountManager.GetDxtUsersAccountList = {
  methodName: "GetDxtUsersAccountList",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.GetDxtUsersAccountListReq,
  responseType: account_manager_pb.GetDxtUsersAccountListReply
};

AccountManager.GetTradeLockerUsersAccountList = {
  methodName: "GetTradeLockerUsersAccountList",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.GetTradeLockerUsersAccountListReq,
  responseType: account_manager_pb.GetTradeLockerUsersAccountListReply
};

AccountManager.AdminGetTradeLockerUsersAccountList = {
  methodName: "AdminGetTradeLockerUsersAccountList",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminGetTradeLockerUsersAccountListReq,
  responseType: account_manager_pb.AdminGetTradeLockerUsersAccountListReply
};

AccountManager.GetMatchTraderUsersAccountList = {
  methodName: "GetMatchTraderUsersAccountList",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.GetMatchTraderUsersAccountListReq,
  responseType: account_manager_pb.GetMatchTraderUsersAccountListReply
};

AccountManager.AdminGetMatchTraderUsersAccountList = {
  methodName: "AdminGetMatchTraderUsersAccountList",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AdminGetMatchTraderUsersAccountListReq,
  responseType: account_manager_pb.AdminGetMatchTraderUsersAccountListReply
};

AccountManager.GetTradovateUserAccountList = {
  methodName: "GetTradovateUserAccountList",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.GetTradovateUserAccountListReq,
  responseType: account_manager_pb.GetTradovateUserAccountListReply
};

AccountManager.SaveTradovateAuthInfo = {
  methodName: "SaveTradovateAuthInfo",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.SaveTradovateAuthInfoReq,
  responseType: account_manager_pb.SaveTradovateAuthInfoReply
};

AccountManager.UpdateTradovateAuthInfo = {
  methodName: "UpdateTradovateAuthInfo",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.UpdateTradovateAuthInfoReq,
  responseType: account_manager_pb.UpdateTradovateAuthInfoReply
};

AccountManager.DeleteTradovateAuthInfo = {
  methodName: "DeleteTradovateAuthInfo",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.DeleteTradovateAuthInfoReq,
  responseType: account_manager_pb.DeleteTradovateAuthInfoReply
};

AccountManager.GetTradovateProfileList = {
  methodName: "GetTradovateProfileList",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.GetTradovateProfileListReq,
  responseType: account_manager_pb.GetTradovateProfileListReply
};

AccountManager.GetProjectxUserAccountList = {
  methodName: "GetProjectxUserAccountList",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.GetProjectxUserAccountListReq,
  responseType: account_manager_pb.GetProjectxUserAccountListReply
};

AccountManager.GetRithmicUserAccountList = {
  methodName: "GetRithmicUserAccountList",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.GetRithmicUserAccountListReq,
  responseType: account_manager_pb.GetRithmicUserAccountListReply
};

AccountManager.ImportExchangeSymbolsForAccount = {
  methodName: "ImportExchangeSymbolsForAccount",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.ImportExchangeSymbolsForAccountReq,
  responseType: account_manager_pb.ImportExchangeSymbolsForAccountReply
};

AccountManager.ListAccountExchanges = {
  methodName: "ListAccountExchanges",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.ListAccountExchangesReq,
  responseType: account_manager_pb.ListAccountExchangesReply
};

AccountManager.ListExchangeProducts = {
  methodName: "ListExchangeProducts",
  service: AccountManager,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.ListExchangeProductsReq,
  responseType: account_manager_pb.ListExchangeProductsReply
};

exports.AccountManager = AccountManager;

function AccountManagerClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

AccountManagerClient.prototype.addAccount = function addAccount(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AddAccount, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.getAccountInfo = function getAccountInfo(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.GetAccountInfo, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.deleteAccount = function deleteAccount(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.DeleteAccount, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.getAccountList = function getAccountList(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.GetAccountList, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.updateAccount = function updateAccount(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.UpdateAccount, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.enableAccount = function enableAccount(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.EnableAccount, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.closeAccountsTrades = function closeAccountsTrades(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.CloseAccountsTrades, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.openTradeWarning = function openTradeWarning(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.OpenTradeWarning, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.activateBetaConnection = function activateBetaConnection(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.ActivateBetaConnection, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.getUsersTradingPlatforms = function getUsersTradingPlatforms(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.GetUsersTradingPlatforms, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.activateAnalyzer = function activateAnalyzer(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.ActivateAnalyzer, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.upsertEPSettings = function upsertEPSettings(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.UpsertEPSettings, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.getEPSettings = function getEPSettings(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.GetEPSettings, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.upsertMcpSettings = function upsertMcpSettings(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.UpsertMcpSettings, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.getMcpSettings = function getMcpSettings(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.GetMcpSettings, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.getMcpAuditLogs = function getMcpAuditLogs(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.GetMcpAuditLogs, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.listIndicatorScripts = function listIndicatorScripts(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.ListIndicatorScripts, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.getIndicatorScript = function getIndicatorScript(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.GetIndicatorScript, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.createIndicatorScript = function createIndicatorScript(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.CreateIndicatorScript, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.updateIndicatorScript = function updateIndicatorScript(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.UpdateIndicatorScript, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.deleteIndicatorScript = function deleteIndicatorScript(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.DeleteIndicatorScript, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.listAccountSymbols = function listAccountSymbols(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.ListAccountSymbols, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.enableAccountSymbol = function enableAccountSymbol(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.EnableAccountSymbol, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.enableAllAccountSymbols = function enableAllAccountSymbols(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.EnableAllAccountSymbols, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.compareSymbols = function compareSymbols(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.CompareSymbols, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.symbolStats = function symbolStats(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.SymbolStats, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.unmappedSymbolList = function unmappedSymbolList(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.UnmappedSymbolList, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.autoMapSymbols = function autoMapSymbols(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AutoMapSymbols, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.mappedSymbolList = function mappedSymbolList(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.MappedSymbolList, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.groupList = function groupList(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.GroupList, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.symbolLotOverride = function symbolLotOverride(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.SymbolLotOverride, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.deleteSymbolLotOverride = function deleteSymbolLotOverride(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.DeleteSymbolLotOverride, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminDeleteSymbolLotOverride = function adminDeleteSymbolLotOverride(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminDeleteSymbolLotOverride, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminSymbolLotOverride = function adminSymbolLotOverride(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminSymbolLotOverride, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.listCopiedTrades = function listCopiedTrades(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.ListCopiedTrades, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.getCopiedTradeLogs = function getCopiedTradeLogs(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.GetCopiedTradeLogs, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.updateDedicatedEnv = function updateDedicatedEnv(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.UpdateDedicatedEnv, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.getUsersDedicatedEnvList = function getUsersDedicatedEnvList(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.GetUsersDedicatedEnvList, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.checkAvailableEnv = function checkAvailableEnv(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.CheckAvailableEnv, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.changeAccountEnv = function changeAccountEnv(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.ChangeAccountEnv, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.getUsersRithmicProfiles = function getUsersRithmicProfiles(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.GetUsersRithmicProfiles, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.changeProfileEnv = function changeProfileEnv(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.ChangeProfileEnv, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminAddAccount = function adminAddAccount(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminAddAccount, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminChangeAccountConnectionType = function adminChangeAccountConnectionType(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminChangeAccountConnectionType, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminGetUserAccounts = function adminGetUserAccounts(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminGetUserAccounts, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminGetAccountInfo = function adminGetAccountInfo(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminGetAccountInfo, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminListAccounts = function adminListAccounts(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminListAccounts, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminDeleteAccount = function adminDeleteAccount(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminDeleteAccount, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminGetAccountStatus = function adminGetAccountStatus(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminGetAccountStatus, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminCopierLogs = function adminCopierLogs(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminCopierLogs, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminCopiedTradeLogs = function adminCopiedTradeLogs(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminCopiedTradeLogs, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminEnableAccount = function adminEnableAccount(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminEnableAccount, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminCloseAccountsTrades = function adminCloseAccountsTrades(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminCloseAccountsTrades, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminGetEPSettings = function adminGetEPSettings(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminGetEPSettings, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminGetUsersDedicatedEnvList = function adminGetUsersDedicatedEnvList(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminGetUsersDedicatedEnvList, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminChangeAccountEnv = function adminChangeAccountEnv(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminChangeAccountEnv, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminGetUsersRithmicProfiles = function adminGetUsersRithmicProfiles(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminGetUsersRithmicProfiles, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminChangeProfileEnv = function adminChangeProfileEnv(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminChangeProfileEnv, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminActivateBetaConnection = function adminActivateBetaConnection(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminActivateBetaConnection, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminBlockAccount = function adminBlockAccount(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminBlockAccount, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminBlockAccountList = function adminBlockAccountList(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminBlockAccountList, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminSyncSymbols = function adminSyncSymbols(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminSyncSymbols, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminListAccountSymbols = function adminListAccountSymbols(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminListAccountSymbols, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminCompareSymbols = function adminCompareSymbols(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminCompareSymbols, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminSymbolStats = function adminSymbolStats(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminSymbolStats, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminUnmappedSymbolList = function adminUnmappedSymbolList(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminUnmappedSymbolList, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminAutoMapSymbols = function adminAutoMapSymbols(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminAutoMapSymbols, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminMappedSymbolList = function adminMappedSymbolList(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminMappedSymbolList, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminGroupList = function adminGroupList(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminGroupList, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminEnableAccountSymbol = function adminEnableAccountSymbol(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminEnableAccountSymbol, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminEnableAllAccountSymbols = function adminEnableAllAccountSymbols(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminEnableAllAccountSymbols, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminAddPool = function adminAddPool(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminAddPool, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminUpdatePool = function adminUpdatePool(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminUpdatePool, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminDeletePool = function adminDeletePool(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminDeletePool, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminListPools = function adminListPools(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminListPools, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminAddSymbolPool = function adminAddSymbolPool(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminAddSymbolPool, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminUpdateSymbolPool = function adminUpdateSymbolPool(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminUpdateSymbolPool, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminDeleteSymbolPool = function adminDeleteSymbolPool(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminDeleteSymbolPool, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminAddIpPool = function adminAddIpPool(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminAddIpPool, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminUpdateIpPool = function adminUpdateIpPool(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminUpdateIpPool, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminDeleteIpPool = function adminDeleteIpPool(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminDeleteIpPool, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminAddSymbolOverride = function adminAddSymbolOverride(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminAddSymbolOverride, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminListSymbolOverrides = function adminListSymbolOverrides(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminListSymbolOverrides, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminDeleteSymbolOverride = function adminDeleteSymbolOverride(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminDeleteSymbolOverride, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminUpdateSymbolOverride = function adminUpdateSymbolOverride(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminUpdateSymbolOverride, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminGetClusterList = function adminGetClusterList(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminGetClusterList, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminSwitchConnectionCluster = function adminSwitchConnectionCluster(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminSwitchConnectionCluster, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.getAllowedCTraderAccounts = function getAllowedCTraderAccounts(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.GetAllowedCTraderAccounts, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.saveCTraderAuthInfo = function saveCTraderAuthInfo(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.SaveCTraderAuthInfo, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.updateCTraderAuthInfo = function updateCTraderAuthInfo(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.UpdateCTraderAuthInfo, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.deleteCTraderAuthInfo = function deleteCTraderAuthInfo(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.DeleteCTraderAuthInfo, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.getCTraderAuthenticatedProfileList = function getCTraderAuthenticatedProfileList(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.GetCTraderAuthenticatedProfileList, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.getDxtUsersAccountList = function getDxtUsersAccountList(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.GetDxtUsersAccountList, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.getTradeLockerUsersAccountList = function getTradeLockerUsersAccountList(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.GetTradeLockerUsersAccountList, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminGetTradeLockerUsersAccountList = function adminGetTradeLockerUsersAccountList(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminGetTradeLockerUsersAccountList, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.getMatchTraderUsersAccountList = function getMatchTraderUsersAccountList(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.GetMatchTraderUsersAccountList, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.adminGetMatchTraderUsersAccountList = function adminGetMatchTraderUsersAccountList(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.AdminGetMatchTraderUsersAccountList, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.getTradovateUserAccountList = function getTradovateUserAccountList(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.GetTradovateUserAccountList, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.saveTradovateAuthInfo = function saveTradovateAuthInfo(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.SaveTradovateAuthInfo, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.updateTradovateAuthInfo = function updateTradovateAuthInfo(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.UpdateTradovateAuthInfo, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.deleteTradovateAuthInfo = function deleteTradovateAuthInfo(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.DeleteTradovateAuthInfo, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.getTradovateProfileList = function getTradovateProfileList(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.GetTradovateProfileList, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.getProjectxUserAccountList = function getProjectxUserAccountList(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.GetProjectxUserAccountList, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.getRithmicUserAccountList = function getRithmicUserAccountList(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.GetRithmicUserAccountList, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.importExchangeSymbolsForAccount = function importExchangeSymbolsForAccount(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.ImportExchangeSymbolsForAccount, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.listAccountExchanges = function listAccountExchanges(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.ListAccountExchanges, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

AccountManagerClient.prototype.listExchangeProducts = function listExchangeProducts(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(AccountManager.ListExchangeProducts, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.AccountManagerClient = AccountManagerClient;

var Internal = (function () {
  function Internal() {}
  Internal.serviceName = "accountmanager.Internal";
  return Internal;
}());

Internal.IntGetAccountsWithIDs = {
  methodName: "IntGetAccountsWithIDs",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.IntGetAccountsWithIDsReq,
  responseType: account_manager_pb.IntGetAccountsWithIDsReply
};

Internal.IntGetAccountsInfo = {
  methodName: "IntGetAccountsInfo",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.IntGetAccountsInfoReq,
  responseType: account_manager_pb.IntGetAccountsInfoReply
};

Internal.IntAdjustActiveAccounts = {
  methodName: "IntAdjustActiveAccounts",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.IntAdjustActiveAccountsReq,
  responseType: account_manager_pb.IntAdjustActiveAccountsReply
};

Internal.IntReactivateAccounts = {
  methodName: "IntReactivateAccounts",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.IntReactivateAccountsReq,
  responseType: account_manager_pb.IntReactivateAccountsReply
};

Internal.IntConnectAccountBulk = {
  methodName: "IntConnectAccountBulk",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.IntConnectAccountBulkReq,
  responseType: account_manager_pb.IntConnectAccountBulkReply
};

Internal.IntUserActiveAccounts = {
  methodName: "IntUserActiveAccounts",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.IntUserActiveAccountsReq,
  responseType: account_manager_pb.IntUserActiveAccountsReply
};

Internal.IntFilterSymbols = {
  methodName: "IntFilterSymbols",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.IntFilterSymbolReq,
  responseType: account_manager_pb.IntFilterSymbolReply
};

Internal.IntSyncSymbols = {
  methodName: "IntSyncSymbols",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.IntSyncSymbolsReq,
  responseType: account_manager_pb.IntSyncSymbolsReply
};

Internal.IntSyncProxyConnections = {
  methodName: "IntSyncProxyConnections",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.IntSyncProxyConnectionsReq,
  responseType: account_manager_pb.IntSyncProxyConnectionsReply
};

Internal.IntGetTotalAndTodaysAccountCount = {
  methodName: "IntGetTotalAndTodaysAccountCount",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.IntGetTotalAndTodaysAccountCountReq,
  responseType: account_manager_pb.IntGetTotalAndTodaysAccountCountReply
};

Internal.IntChangeConnectionTypeBulk = {
  methodName: "IntChangeConnectionTypeBulk",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.IntChangeConnectionTypeBulkReq,
  responseType: account_manager_pb.IntChangeConnectionTypeBulkReply
};

Internal.IntSymbolExistsInAccount = {
  methodName: "IntSymbolExistsInAccount",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.IntSymbolExistsInAccountReq,
  responseType: account_manager_pb.IntSymbolExistsInAccountReply
};

Internal.IntGetAccountCurrencies = {
  methodName: "IntGetAccountCurrencies",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.IntGetAccountCurrenciesReq,
  responseType: account_manager_pb.IntGetAccountCurrenciesReply
};

Internal.IntGetAccountDetails = {
  methodName: "IntGetAccountDetails",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.IntGetAccountDetailsReq,
  responseType: account_manager_pb.IntGetAccountDetailsReply
};

Internal.IntSyncCurrency = {
  methodName: "IntSyncCurrency",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.IntSyncCurrencyReq,
  responseType: account_manager_pb.IntSyncCurrencyReply
};

Internal.IntEnableAccounts = {
  methodName: "IntEnableAccounts",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.IntEnableAccountsReq,
  responseType: account_manager_pb.IntEnableAccountsReply
};

Internal.IntGetUserAccountCount = {
  methodName: "IntGetUserAccountCount",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.IntGetUserAccountCountReq,
  responseType: account_manager_pb.IntGetUserAccountCountReply
};

Internal.IntGetUsersAccountCount = {
  methodName: "IntGetUsersAccountCount",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.IntGetUsersAccountCountReq,
  responseType: account_manager_pb.IntGetUsersAccountCountReply
};

Internal.IntUpdateAccountServerTimeZone = {
  methodName: "IntUpdateAccountServerTimeZone",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.IntUpdateAccountServerTimeZoneReq,
  responseType: account_manager_pb.IntUpdateAccountServerTimeZoneReply
};

Internal.IntAdjustDedicatedEnv = {
  methodName: "IntAdjustDedicatedEnv",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.IntAdjustDedicatedEnvReq,
  responseType: account_manager_pb.IntAdjustDedicatedEnvReply
};

Internal.IntInternalAccountsInfo = {
  methodName: "IntInternalAccountsInfo",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.IntInternalAccountsInfoReq,
  responseType: account_manager_pb.IntInternalAccountsInfoReply
};

Internal.IntAddAccount = {
  methodName: "IntAddAccount",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AddAccountReq,
  responseType: account_manager_pb.AddAccountReply
};

Internal.IntGetAccountInfo = {
  methodName: "IntGetAccountInfo",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.GetAccountInfoReq,
  responseType: account_manager_pb.GetAccountInfoReply
};

Internal.IntDeleteAccount = {
  methodName: "IntDeleteAccount",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.DeleteAccountReq,
  responseType: account_manager_pb.DeleteAccountReply
};

Internal.IntGetAccountList = {
  methodName: "IntGetAccountList",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AccountListReq,
  responseType: account_manager_pb.AccountListReply
};

Internal.IntUpdateAccount = {
  methodName: "IntUpdateAccount",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.UpdateAccountReq,
  responseType: account_manager_pb.UpdateAccountReply
};

Internal.IntEnableAccount = {
  methodName: "IntEnableAccount",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.EnableAccountReq,
  responseType: account_manager_pb.EnableAccountReply
};

Internal.IntCloseAccountsTrades = {
  methodName: "IntCloseAccountsTrades",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.CloseAccountsTradesReq,
  responseType: account_manager_pb.CloseAccountsTradesReply
};

Internal.IntOpenTradeWarning = {
  methodName: "IntOpenTradeWarning",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.OpenTradeWarningReq,
  responseType: account_manager_pb.OpenTradeWarningReply
};

Internal.IntActivateBetaConnection = {
  methodName: "IntActivateBetaConnection",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.ActivateBetaConnectionReq,
  responseType: account_manager_pb.ActivateBetaConnectionReply
};

Internal.IntGetUsersTradingPlatforms = {
  methodName: "IntGetUsersTradingPlatforms",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.GetUsersTradingPlatformsReq,
  responseType: account_manager_pb.GetUsersTradingPlatformsReply
};

Internal.IntActivateAnalyzer = {
  methodName: "IntActivateAnalyzer",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.ActivateAnalyzerReq,
  responseType: account_manager_pb.ActivateAnalyzerReply
};

Internal.IntListAccountExchanges = {
  methodName: "IntListAccountExchanges",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.ListAccountExchangesReq,
  responseType: account_manager_pb.ListAccountExchangesReply
};

Internal.IntListExchangeProducts = {
  methodName: "IntListExchangeProducts",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.ListExchangeProductsReq,
  responseType: account_manager_pb.ListExchangeProductsReply
};

Internal.IntImportExchangeSymbolsForAccount = {
  methodName: "IntImportExchangeSymbolsForAccount",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.ImportExchangeSymbolsForAccountReq,
  responseType: account_manager_pb.ImportExchangeSymbolsForAccountReply
};

Internal.IntUpsertEPSettings = {
  methodName: "IntUpsertEPSettings",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.UpsertEPSettingsReq,
  responseType: account_manager_pb.UpsertEPSettingsReply
};

Internal.IntGetEPSettings = {
  methodName: "IntGetEPSettings",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.GetEPSettingsReq,
  responseType: account_manager_pb.GetEPSettingsReply
};

Internal.IntGetUsersDedicatedEnvList = {
  methodName: "IntGetUsersDedicatedEnvList",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.GetUsersDedicatedEnvListReq,
  responseType: account_manager_pb.GetUsersDedicatedEnvListReply
};

Internal.IntChangeAccountEnv = {
  methodName: "IntChangeAccountEnv",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.ChangeAccountEnvReq,
  responseType: account_manager_pb.ChangeAccountEnvReply
};

Internal.IntListCopiedTrades = {
  methodName: "IntListCopiedTrades",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.ListCopiedTradesReq,
  responseType: account_manager_pb.ListCopiedTradesReply
};

Internal.IntCompareSymbols = {
  methodName: "IntCompareSymbols",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.CompareSymbolsReq,
  responseType: account_manager_pb.CompareSymbolsReply
};

Internal.IntSymbolStats = {
  methodName: "IntSymbolStats",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.SymbolStatsReq,
  responseType: account_manager_pb.SymbolStatsReply
};

Internal.IntUnmappedSymbolList = {
  methodName: "IntUnmappedSymbolList",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.UnmappedSymbolListReq,
  responseType: account_manager_pb.UnmappedSymbolListReply
};

Internal.IntAutoMapSymbols = {
  methodName: "IntAutoMapSymbols",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.AutoMapSymbolsReq,
  responseType: account_manager_pb.AutoMapSymbolsReply
};

Internal.IntGroupList = {
  methodName: "IntGroupList",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.GroupListReq,
  responseType: account_manager_pb.GroupListReply
};

Internal.IntListAccountSymbols = {
  methodName: "IntListAccountSymbols",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.ListAccountSymbolsReq,
  responseType: account_manager_pb.ListAccountSymbolsReply
};

Internal.IntEnableAccountSymbol = {
  methodName: "IntEnableAccountSymbol",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.EnableAccountSymbolReq,
  responseType: account_manager_pb.EnableAccountSymbolReply
};

Internal.IntEnableAllAccountSymbols = {
  methodName: "IntEnableAllAccountSymbols",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.EnableAllAccountSymbolsReq,
  responseType: account_manager_pb.EnableAllAccountSymbolsReply
};

Internal.IntSymbolLotOverride = {
  methodName: "IntSymbolLotOverride",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.SymbolLotOverrideReq,
  responseType: account_manager_pb.SymbolLotOverrideReply
};

Internal.IntDeleteSymbolLotOverride = {
  methodName: "IntDeleteSymbolLotOverride",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.DeleteSymbolLotOverrideReq,
  responseType: account_manager_pb.DeleteSymbolLotOverrideReply
};

Internal.IntGetDxtUsersAccountList = {
  methodName: "IntGetDxtUsersAccountList",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.GetDxtUsersAccountListReq,
  responseType: account_manager_pb.GetDxtUsersAccountListReply
};

Internal.IntGetTradeLockerUsersAccountList = {
  methodName: "IntGetTradeLockerUsersAccountList",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.GetTradeLockerUsersAccountListReq,
  responseType: account_manager_pb.GetTradeLockerUsersAccountListReply
};

Internal.IntGetMatchTraderUsersAccountList = {
  methodName: "IntGetMatchTraderUsersAccountList",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.GetMatchTraderUsersAccountListReq,
  responseType: account_manager_pb.GetMatchTraderUsersAccountListReply
};

Internal.IntGetProjectxUserAccountList = {
  methodName: "IntGetProjectxUserAccountList",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.GetProjectxUserAccountListReq,
  responseType: account_manager_pb.GetProjectxUserAccountListReply
};

Internal.IntGetRithmicUserAccountList = {
  methodName: "IntGetRithmicUserAccountList",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.GetRithmicUserAccountListReq,
  responseType: account_manager_pb.GetRithmicUserAccountListReply
};

Internal.IntGetTradovateProfileList = {
  methodName: "IntGetTradovateProfileList",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.GetTradovateProfileListReq,
  responseType: account_manager_pb.GetTradovateProfileListReply
};

Internal.IntGetCTraderAuthenticatedProfileList = {
  methodName: "IntGetCTraderAuthenticatedProfileList",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.GetCTraderAuthenticatedProfileListReq,
  responseType: account_manager_pb.GetCTraderAuthenticatedProfileListReply
};

Internal.IntGetTradovateUserAccountList = {
  methodName: "IntGetTradovateUserAccountList",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.GetTradovateUserAccountListReq,
  responseType: account_manager_pb.GetTradovateUserAccountListReply
};

Internal.IntSaveTradovateAuthInfo = {
  methodName: "IntSaveTradovateAuthInfo",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.SaveTradovateAuthInfoReq,
  responseType: account_manager_pb.SaveTradovateAuthInfoReply
};

Internal.IntSaveCTraderAuthInfo = {
  methodName: "IntSaveCTraderAuthInfo",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.SaveCTraderAuthInfoReq,
  responseType: account_manager_pb.SaveCTraderAuthInfoReply
};

Internal.IntGetAllowedCTraderAccounts = {
  methodName: "IntGetAllowedCTraderAccounts",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.GetAllowedCTraderAccountsReq,
  responseType: account_manager_pb.GetAllowedCTraderAccountsReply
};

Internal.IntUpdateCTraderAuthInfo = {
  methodName: "IntUpdateCTraderAuthInfo",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.UpdateCTraderAuthInfoReq,
  responseType: account_manager_pb.UpdateCTraderAuthInfoReply
};

Internal.IntDeleteCTraderAuthInfo = {
  methodName: "IntDeleteCTraderAuthInfo",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.DeleteCTraderAuthInfoReq,
  responseType: account_manager_pb.DeleteCTraderAuthInfoReply
};

Internal.IntUpdateTradovateAuthInfo = {
  methodName: "IntUpdateTradovateAuthInfo",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.UpdateTradovateAuthInfoReq,
  responseType: account_manager_pb.UpdateTradovateAuthInfoReply
};

Internal.IntDeleteTradovateAuthInfo = {
  methodName: "IntDeleteTradovateAuthInfo",
  service: Internal,
  requestStream: false,
  responseStream: false,
  requestType: account_manager_pb.DeleteTradovateAuthInfoReq,
  responseType: account_manager_pb.DeleteTradovateAuthInfoReply
};

exports.Internal = Internal;

function InternalClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

InternalClient.prototype.intGetAccountsWithIDs = function intGetAccountsWithIDs(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntGetAccountsWithIDs, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intGetAccountsInfo = function intGetAccountsInfo(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntGetAccountsInfo, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intAdjustActiveAccounts = function intAdjustActiveAccounts(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntAdjustActiveAccounts, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intReactivateAccounts = function intReactivateAccounts(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntReactivateAccounts, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intConnectAccountBulk = function intConnectAccountBulk(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntConnectAccountBulk, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intUserActiveAccounts = function intUserActiveAccounts(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntUserActiveAccounts, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intFilterSymbols = function intFilterSymbols(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntFilterSymbols, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intSyncSymbols = function intSyncSymbols(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntSyncSymbols, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intSyncProxyConnections = function intSyncProxyConnections(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntSyncProxyConnections, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intGetTotalAndTodaysAccountCount = function intGetTotalAndTodaysAccountCount(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntGetTotalAndTodaysAccountCount, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intChangeConnectionTypeBulk = function intChangeConnectionTypeBulk(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntChangeConnectionTypeBulk, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intSymbolExistsInAccount = function intSymbolExistsInAccount(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntSymbolExistsInAccount, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intGetAccountCurrencies = function intGetAccountCurrencies(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntGetAccountCurrencies, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intGetAccountDetails = function intGetAccountDetails(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntGetAccountDetails, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intSyncCurrency = function intSyncCurrency(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntSyncCurrency, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intEnableAccounts = function intEnableAccounts(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntEnableAccounts, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intGetUserAccountCount = function intGetUserAccountCount(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntGetUserAccountCount, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intGetUsersAccountCount = function intGetUsersAccountCount(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntGetUsersAccountCount, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intUpdateAccountServerTimeZone = function intUpdateAccountServerTimeZone(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntUpdateAccountServerTimeZone, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intAdjustDedicatedEnv = function intAdjustDedicatedEnv(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntAdjustDedicatedEnv, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intInternalAccountsInfo = function intInternalAccountsInfo(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntInternalAccountsInfo, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intAddAccount = function intAddAccount(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntAddAccount, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intGetAccountInfo = function intGetAccountInfo(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntGetAccountInfo, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intDeleteAccount = function intDeleteAccount(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntDeleteAccount, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intGetAccountList = function intGetAccountList(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntGetAccountList, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intUpdateAccount = function intUpdateAccount(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntUpdateAccount, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intEnableAccount = function intEnableAccount(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntEnableAccount, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intCloseAccountsTrades = function intCloseAccountsTrades(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntCloseAccountsTrades, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intOpenTradeWarning = function intOpenTradeWarning(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntOpenTradeWarning, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intActivateBetaConnection = function intActivateBetaConnection(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntActivateBetaConnection, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intGetUsersTradingPlatforms = function intGetUsersTradingPlatforms(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntGetUsersTradingPlatforms, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intActivateAnalyzer = function intActivateAnalyzer(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntActivateAnalyzer, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intListAccountExchanges = function intListAccountExchanges(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntListAccountExchanges, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intListExchangeProducts = function intListExchangeProducts(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntListExchangeProducts, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intImportExchangeSymbolsForAccount = function intImportExchangeSymbolsForAccount(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntImportExchangeSymbolsForAccount, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intUpsertEPSettings = function intUpsertEPSettings(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntUpsertEPSettings, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intGetEPSettings = function intGetEPSettings(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntGetEPSettings, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intGetUsersDedicatedEnvList = function intGetUsersDedicatedEnvList(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntGetUsersDedicatedEnvList, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intChangeAccountEnv = function intChangeAccountEnv(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntChangeAccountEnv, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intListCopiedTrades = function intListCopiedTrades(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntListCopiedTrades, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intCompareSymbols = function intCompareSymbols(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntCompareSymbols, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intSymbolStats = function intSymbolStats(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntSymbolStats, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intUnmappedSymbolList = function intUnmappedSymbolList(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntUnmappedSymbolList, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intAutoMapSymbols = function intAutoMapSymbols(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntAutoMapSymbols, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intGroupList = function intGroupList(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntGroupList, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intListAccountSymbols = function intListAccountSymbols(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntListAccountSymbols, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intEnableAccountSymbol = function intEnableAccountSymbol(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntEnableAccountSymbol, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intEnableAllAccountSymbols = function intEnableAllAccountSymbols(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntEnableAllAccountSymbols, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intSymbolLotOverride = function intSymbolLotOverride(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntSymbolLotOverride, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intDeleteSymbolLotOverride = function intDeleteSymbolLotOverride(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntDeleteSymbolLotOverride, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intGetDxtUsersAccountList = function intGetDxtUsersAccountList(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntGetDxtUsersAccountList, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intGetTradeLockerUsersAccountList = function intGetTradeLockerUsersAccountList(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntGetTradeLockerUsersAccountList, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intGetMatchTraderUsersAccountList = function intGetMatchTraderUsersAccountList(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntGetMatchTraderUsersAccountList, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intGetProjectxUserAccountList = function intGetProjectxUserAccountList(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntGetProjectxUserAccountList, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intGetRithmicUserAccountList = function intGetRithmicUserAccountList(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntGetRithmicUserAccountList, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intGetTradovateProfileList = function intGetTradovateProfileList(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntGetTradovateProfileList, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intGetCTraderAuthenticatedProfileList = function intGetCTraderAuthenticatedProfileList(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntGetCTraderAuthenticatedProfileList, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intGetTradovateUserAccountList = function intGetTradovateUserAccountList(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntGetTradovateUserAccountList, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intSaveTradovateAuthInfo = function intSaveTradovateAuthInfo(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntSaveTradovateAuthInfo, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intSaveCTraderAuthInfo = function intSaveCTraderAuthInfo(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntSaveCTraderAuthInfo, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intGetAllowedCTraderAccounts = function intGetAllowedCTraderAccounts(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntGetAllowedCTraderAccounts, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intUpdateCTraderAuthInfo = function intUpdateCTraderAuthInfo(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntUpdateCTraderAuthInfo, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intDeleteCTraderAuthInfo = function intDeleteCTraderAuthInfo(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntDeleteCTraderAuthInfo, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intUpdateTradovateAuthInfo = function intUpdateTradovateAuthInfo(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntUpdateTradovateAuthInfo, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

InternalClient.prototype.intDeleteTradovateAuthInfo = function intDeleteTradovateAuthInfo(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Internal.IntDeleteTradovateAuthInfo, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.InternalClient = InternalClient;

